import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InactivityTimerService {
  private idleTimeLimit = 60 * 60 * 1000;
  private lastActiveTime = Date.now();
  interval: any;

  private userLoggedOut = new BehaviorSubject<boolean>(false);

  constructor(private router: Router,private ngZone: NgZone) {
    this.startIdleTimer();
    this.trackUserActivity();
    this.listenForActivityUpdates();
  }

    private startIdleTimer() {
      this.ngZone.runOutsideAngular(() => {
        this.interval = setInterval(() => {
          const now = Date.now();
          const lastActive = Number(localStorage.getItem('lastActiveTime')) || now;
  
          if (now - lastActive >= this.idleTimeLimit) {
            this.checkAllTabsIdle();
          }
        }, 60 * 1000);
      });
    }
  
    
    private trackUserActivity() {
      window.addEventListener('mousemove', () => this.updateLastActiveTime());
      window.addEventListener('keydown', () => this.updateLastActiveTime());
      window.addEventListener('click', () => this.updateLastActiveTime());
    }
  
    private updateLastActiveTime() {
      if(localStorage.getItem('access_token')){
        this.lastActiveTime = Date.now();
        localStorage.setItem('lastActiveTime', this.lastActiveTime.toString());
    
        
        localStorage.setItem('activityEvent', JSON.stringify({ timestamp: this.lastActiveTime }));
      }
    }
  
    
    private listenForActivityUpdates() {
      window.addEventListener('storage', (event) => {
        if (event.key === 'activityEvent') {
          this.lastActiveTime = Date.now();
        }
      });
    }
  
    private checkAllTabsIdle() {
      const now = Date.now();
      const lastActive = Number(localStorage.getItem('lastActiveTime')) || now;
  
      if (now - lastActive >= this.idleTimeLimit) {
        this.logout()
      }
    }
  

  private logout(): void {
    const visitorCount = sessionStorage.getItem("visitorCount") || '';
    localStorage.clear() 
    sessionStorage.clear();
    if (visitorCount !== null) {
      sessionStorage.setItem("visitorCount", visitorCount);
    }
    this.userLoggedOut.next(true);
    this.router.navigate(['/home']);
  }

  public get userLoggedOut$() {
    return this.userLoggedOut.asObservable();
  }
}
